'use strict';
// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/deprecation-decorator/node_modules/core-js/internals/enum-bug-keys.js
// module id = 6129
// module chunks = 25